import {createContext} from "react";

export const CancellationReasonContext = createContext({
    selectedReason: null,
    setReason: () => {},
    dayCount: 10,
    setDayCount: () => {},
    // return mode asked when opening a return, on organizations offering it (see ReturnResolutionSelect)
    isReturnResolutionRequired: false,
    returnResolution: null,
    setReturnResolution: () => {}
})
